import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
import AssetSlider from "../Sliders/AssetSlider";
import { ASSET_TYPES, fetchAssetsByType } from "../../api/assetApi";

export default function OccultTraining() {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    fetchAssetsByType(ASSET_TYPES.CLASSES)
      .then((items) => {
        if (!cancelled) setClasses(items);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Failed to load classes");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="space-top">
      <div className="container">
        <div className="d-flex justify-content-between align-items-start gap-3 mb-4">
          <div>
            <h2 className="text-lora font-semibold">Occult Training Classes</h2>
            <p>
              Learn astrology, Vastu, numerology, and sacred sciences from
              experienced mentors.
            </p>
          </div>
          <NavLink to="/training-classes" className="text-dark no-underline">
            View All <FaArrowRightLong className="ms-2 d-inline" />
          </NavLink>
        </div>

        {loading && <p className="text-center py-4">Loading classes...</p>}
        {error && <p className="text-center text-danger py-4">{error}</p>}
        {!loading && !error && classes.length === 0 && (
          <p className="text-center py-4">No classes available.</p>
        )}
        {classes.length > 0 && (
          <AssetSlider
            assets={classes}
            actionLabel="Enroll Now"
            actionTo="/enroll"
          />
        )}
      </div>
    </section>
  );
}
